export default "../css/2615b19ab6fb503e6bb74afde40536fc.ttf";